// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function make(contentMd5, existingAttemptId, insertAttempt, updateActivityCompleted, updateState, insertResponse) {
  var attemptId = {
    contents: existingAttemptId
  };
  var p = {
    contents: Promise.resolve()
  };
  var idle = function (param) {
    return p.contents;
  };
  var resolveAll = {
    contents: (function () {
        
      })
  };
  var queue = {
    contents: []
  };
  var busy = {
    contents: false
  };
  var getOrMakeAttempt = async function () {
    var id = attemptId.contents;
    var attId = id !== undefined ? id : await insertAttempt();
    attemptId.contents = attId;
    return attId;
  };
  var run = async function ($$event) {
    if (typeof $$event !== "object") {
      var attId = await getOrMakeAttempt();
      await updateActivityCompleted(attId);
    } else if ($$event.TAG === "QuestionAnswered") {
      var attId$1 = await getOrMakeAttempt();
      await insertResponse(attId$1, $$event.answer, $$event.responsesCorrect, $$event.responsesComplete, $$event.passed ? 1 : 0, $$event.questionIndex, $$event.state, contentMd5);
    } else {
      var attId$2 = await getOrMakeAttempt();
      await updateState(attId$2, $$event.questionIndex, $$event.state, contentMd5);
    }
    return next();
  };
  var next = function () {
    var head = queue.contents.shift();
    if (head !== undefined) {
      run(head);
      return ;
    } else {
      busy.contents = false;
      return resolveAll.contents();
    }
  };
  var pushEvent = function ($$event) {
    if (busy.contents) {
      queue.contents = Belt_Array.concatMany([
            queue.contents,
            [$$event]
          ]);
    } else {
      busy.contents = true;
      p.contents = new Promise((function (resolve, param) {
              resolveAll.contents = resolve;
            }));
      run($$event);
    }
  };
  return {
          pushEvent: pushEvent,
          idle: idle
        };
}

export {
  make ,
}
/* No side effect */
